export default __webpack_public_path__ + "static/media/prisn.bbe89047.png";